import { CloseOutlined } from '@mui/icons-material';
import { Box, Dialog, Rating, Typography } from '@mui/material';
import {
  colorLinkGrey,
  colorPrimary,
  colorSecondary,
  colorTextBlack
} from '../../../config/theme';
import {
  getBasicDetails,
  getGamificationDetails
} from '../../../config/cookie';

function UserRatingsModal({ isOpen, onClose }) {
  const basicDetails = JSON.parse(getBasicDetails());
  const gamificationDetails = getGamificationDetails();

  const pointsArray = [
    {
      name: 'Likes',
      points: gamificationDetails?.likePoints || 0
    },
    {
      name: 'Comments',
      points: gamificationDetails?.commentPoints || 0
    },
    {
      name: 'Share',
      points: gamificationDetails?.sharePoints || 0
    },
    {
      name: 'Download',
      points: gamificationDetails?.downloadPoints || 0
    },
    {
      name: 'Quiz',
      points: gamificationDetails?.quizPoints || 0
    }
  ];
  return (
    <>
      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '8px'
          }
        }}
        open={isOpen}
        onClose={onClose}
      >
        <Box sx={{ padding: '40px', width: '459px' }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems={'center'}
            marginBottom="25px"
          >
            <Typography
              style={{
                fontFamily: 'Lato',
                fontSize: '20px',
                fontWeight: 700,
                lineHeight: '26px',
                color: colorTextBlack
              }}
            >
              User Activity & Rewards
            </Typography>

            <CloseOutlined style={{ cursor: 'pointer' }} onClick={onClose} />
          </Box>
          <Box marginBottom={'16px'}>
            <Typography
              style={{
                fontFamily: 'Lato',
                fontSize: '16px',
                fontWeight: 600,
                lineHeight: '20px',
                color: colorTextBlack
              }}
            >
              {basicDetails?.name || ''}
            </Typography>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '5px'
              }}
            >
              <Rating value={1} max={1} readOnly size="medium" />
              <Typography
                style={{
                  fontFamily: 'Lato',
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '18px',
                  color: colorLinkGrey,
                  marginLeft: '5px'
                }}
              >
                {gamificationDetails?.totalPoints} Points
              </Typography>
            </div>
          </Box>
          <Box width={'394px'}>
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              marginBottom={'16px'}
            >
              {pointsArray?.slice(0, 2).map((item, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      paddingLeft: '20px',
                      paddingTop: '12px',
                      backgroundColor: colorSecondary,
                      textTransform: 'none',
                      borderRadius: '8px',
                      color: 'black',
                      borderWidth: '1px',
                      height: '44px',
                      width: '189px',
                      border: `1px solid ${colorPrimary}`,
                      '&:hover': {
                        borderColor: colorPrimary,
                        backgroundColor: 'transparent',
                        borderRadius: '8px',
                        borderWidth: '1px'
                      }
                    }}
                  >
                    <div style={{ display: 'flex' }}>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontWeight: 600,
                          lineHeight: '18px',
                          fontFamily: 'Lato',
                          color: colorLinkGrey
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontWeight: 600,
                          lineHeight: '18px',
                          fontFamily: 'Lato',
                          color: colorTextBlack,
                          marginLeft: '15px'
                        }}
                      >
                        {item?.points}
                      </Typography>
                    </div>
                  </div>
                );
              })}
            </Box>

            <Box
              display={'flex'}
              justifyContent={'space-between'}
              marginBottom={'16px'}
            >
              {pointsArray?.slice(2, 4).map((item, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      paddingLeft: '20px',
                      paddingTop: '12px',
                      backgroundColor: colorSecondary,
                      textTransform: 'none',
                      borderRadius: '8px',
                      color: 'black',
                      borderWidth: '1px',
                      height: '44px',
                      width: '189px',
                      border: `1px solid ${colorPrimary}`,
                      '&:hover': {
                        borderColor: colorPrimary,
                        backgroundColor: 'transparent',
                        borderRadius: '8px',
                        borderWidth: '1px'
                      }
                    }}
                  >
                    <div style={{ display: 'flex' }}>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontWeight: 600,
                          lineHeight: '18px',
                          fontFamily: 'Lato',
                          color: colorLinkGrey
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontWeight: 600,
                          lineHeight: '18px',
                          fontFamily: 'Lato',
                          color: colorTextBlack,
                          marginLeft: '15px'
                        }}
                      >
                        {item?.points}
                      </Typography>
                    </div>
                  </div>
                );
              })}
            </Box>

            <Box display={'flex'} justifyContent={'space-between'}>
              {pointsArray?.slice(4, 6).map((item, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      paddingLeft: '20px',
                      paddingTop: '12px',
                      backgroundColor: colorSecondary,
                      textTransform: 'none',
                      borderRadius: '8px',
                      color: 'black',
                      borderWidth: '1px',
                      height: '44px',
                      width: '189px',
                      border: `1px solid ${colorPrimary}`,
                      '&:hover': {
                        borderColor: colorPrimary,
                        backgroundColor: 'transparent',
                        borderRadius: '8px',
                        borderWidth: '1px'
                      }
                    }}
                  >
                    <div style={{ display: 'flex' }}>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontWeight: 600,
                          lineHeight: '18px',
                          fontFamily: 'Lato',
                          color: colorLinkGrey
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontWeight: 600,
                          lineHeight: '18px',
                          fontFamily: 'Lato',
                          color: colorTextBlack,
                          marginLeft: '15px'
                        }}
                      >
                        {item?.points}
                      </Typography>
                    </div>
                  </div>
                );
              })}
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

export default UserRatingsModal;
